function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7.608 12.5s1.313 1.5 3.5 1.5c2.188 0 3.5-1.5 3.5-1.5m-.75-5h.01m-5.51 0h.01m2.74 11a8.5 8.5 0 10-8.057-5.783c.109.32.163.481.172.604a.899.899 0 01-.027.326c-.03.12-.098.245-.233.494l-1.636 3.027c-.233.432-.35.648-.323.815a.5.5 0 00.233.35c.144.087.388.062.877.011l5.12-.529c.156-.016.233-.024.304-.021.07.002.118.009.186.024.07.016.156.05.33.116a8.478 8.478 0 003.054.566zm3.25-11a.5.5 0 11-1 0 .5.5 0 011 0zm-5.5 0a.5.5 0 11-1 0 .5.5 0 011 0z",
  stroke: "#fff",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));